import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import type { PortfolioButtonProps } from "./types";
import Translations from "@translate/components/PortfolioContainer/PortfolioButton";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const PortfolioButton: React.FC<PortfolioButtonProps> = ({
  type = "create",
  className,
  onClick,
}) => {
  const isManageType = type === "manage";

  return (
    <button
      aria-label="Portfolio Button"
      data-openreplay-label="Portfolio Button Button"
      id="btn-portfolio-button"
      className={cn(
        "bg-background_white_overlay10 relative md:w-56 h-9 rounded-2 mx-2",
        "flex gap-0.5 items-center justify-center min-w-20 px-3 py-2",
        "hover:bg-background_white_overlay15 transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand_primary",
        className,
      )}
      onClick={onClick}
    >
      {!isManageType && (
        <div className="overflow-hidden shrink-0 w-5 h-5 text-content_primary">
          <Icon name="plus" size={20} />
        </div>
      )}
      <div className="button_m text-content_primary whitespace-nowrap">
        {isManageType
          ? I18n.t("Manage my portfolio")
          : I18n.t("Create new portfolio")}
      </div>
    </button>
  );
};
